import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { COMPANY_SELECTION } from "Constants/Routes";
import InvitationCard from '../Components/InvitationCard'
import { inject, observer } from 'mobx-react'
import { Row, Col, Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

const PendingInvitations = ({ CommonStore, userStore }) => {
    const { t } = useTranslation()
    const history = useHistory()

    useEffect(() => {
        CommonStore.loadPendingInvitations()
    }, [CommonStore])

    function handleContinue() {
        history.push(COMPANY_SELECTION)
    }

    return (
        <div className="p-4">
            <h1>{t('pending_invitations') || 'Invitaciones pendientes'}</h1>
            <Button variant="link" onClick={handleContinue} className="mb-3">
                {t('skip') || 'Saltar'}
            </Button>
            {CommonStore.invitations?.length ?
                <Row>
                    {CommonStore.invitations.map(invitation => (
                        <Col key={invitation.TokenRegister} xs={12} sm={12} md={12} lg={6} xl={6} className="mb-3">
                            <InvitationCard invitation={invitation} />
                        </Col>
                    ))}
                </Row>
                :
                <h2>{t('no_pending_invitations') || 'No hay invitaciones pendientes por revisar'}</h2>
            }
        </div>
    )
}

export default inject("CommonStore", "userStore")(observer(PendingInvitations))
